import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import http from "./common/http/index.js";
import tools from "./common/tools/tools.js";
import "vant/lib/button/style";
import "./assets/iconfont/iconfont.css";
import VueI18n from 'vue-i18n';
import cn from './language/cn';
import en from './language/en';
import enUS from 'vant/lib/locale/lang/en-US'
import zhCN from 'vant/lib/locale/lang/zh-CN'
import 'vant/lib/index.less';
import * as filters from '@/common/filters';
// import Video from 'video.js'
// import 'video.js/dist/video-js.css'
// import 'videojs-contrib-hls'
import * as util from './utils/util'
import VueClipboard from 'vue-clipboard2'
import './utils/ranger_extend'
import './styles/index.css' // vant全局样式设置
import moment from 'moment'
import dayjs from 'dayjs'
import './permission'

// Vue.prototype.$video = Video
Vue.prototype.$util = util
Vue.prototype.$utils = util.default
Vue.prototype.moment = moment;
Vue.prototype.$dayjs = dayjs;

import {
    Button,
    Image as VanImage,
    Field,
    Cell,
    CellGroup,
    Icon,
    Picker,
    DatetimePicker,
    Popup,
    Dialog,
    Toast,
    Form,
    Loading,
    Locale,
    Col,
    Row,
    Lazyload,
    Overlay,
    DropdownMenu,
    DropdownItem,
    Search,
    PullRefresh,
    List,
    Radio,
    RadioGroup,
    Tab, Tabs, Popover, Swipe, SwipeItem
} from "vant";

Vue.use(VueI18n)
Vue.use(Button);
Vue.use(VanImage);
Vue.use(Field);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(DatetimePicker);
Vue.use(Toast);
Vue.use(Form);
Vue.use(Loading);
Vue.use(Col);
Vue.use(Row);
Vue.use(Overlay);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Search);
Vue.use(Dialog);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Popover)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Lazyload, {
    lazyComponent: true,
});
Vue.use(VueClipboard)
const i18n = new VueI18n({
    locale: 'cn', // 语言标识
    messages: {
        'cn': {
            ...cn,
            ...zhCN
        }, // 中文语言包
        'en': {
            ...en,
            ...enUS
        }  // 英文语言包
    },
})

Vue.config.productionTip = false;
Vue.prototype.$http = http;
Vue.prototype.$store = store;
Vue.prototype.$tools = tools;
Vue.prototype.$Dialog = Dialog;
Vue.prototype.$Toast = Toast;
// Vue.prototype.$i18n = i18n;
// 定义全局过滤器
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

Object.keys(util).forEach(key => {
    Vue.filter(key, util[key])
})

Vue.config.ignoredElements = ['wx-open-launch-weapp']

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount("#app");